import { ReactElement, useEffect, useState } from 'react';
import {
  Box,
  Card,
  Chip,
  CircularProgress,
  Paper,
  Typography,
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import SectionHeader from 'shared/components/SectionHeader';

import PersonIcon from '@mui/icons-material/Person';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import StorageIcon from '@mui/icons-material/Storage';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { AISolutionProps } from '../../Main';

const AiSolution = (props: any): ReactElement => {
  const {
    aiSolutionList,
  }: {
    aiSolutionList: AISolutionProps[];
  } = props;

  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 1000); // 1 second

    return () => clearTimeout(timer); // cleanup
  }, []);

  return (
    <Paper variant="outlined" className="p-4">
      <SectionHeader
        icon={DescriptionIcon}
        title={`Approved AI Solutions ${
          aiSolutionList.length ? ` (${aiSolutionList.length})` : ''
        }`}
        subtitle="Current AI solutions approved and in use by this organisation"
        titleVariant="h3"
      />
      {showLoader && (
        <Box className="empty-content">
          <CircularProgress />
        </Box>
      )}
      {aiSolutionList.length > 0 && (
        <Box className="ai-grid">
          {aiSolutionList.map((solution) => (
            <Card className="ai-card" key={solution._id}>
              <Typography className="ai-title">
                {solution.solutionName}
              </Typography>

              <Chip
                label={solution.sourceType}
                size="small"
                className="ai-chip"
              />

              <Box className="ai-content">
                <Box className="ai-row">
                  <PersonIcon className="row-icon" />
                  <Box>
                    <Typography className="row-label">Owner</Typography>
                    <Typography className="row-value">
                      {solution.solutionOwner}
                    </Typography>
                  </Box>
                </Box>

                <Box className="ai-row">
                  <TrackChangesIcon className="row-icon" />
                  <Box>
                    <Typography className="row-label">Purpose</Typography>
                    <Typography className="row-value">
                      {solution.purpose}
                    </Typography>
                  </Box>
                </Box>

                <Box className="ai-row">
                  <StorageIcon className="row-icon" />
                  <Box>
                    <Typography className="row-label">Uses</Typography>
                    <Typography className="row-value">
                      {solution.uses}
                    </Typography>
                  </Box>
                </Box>

                <Box className="ai-row">
                  <ShowChartIcon className="row-icon" />
                  <Box>
                    <Typography className="row-label">
                      Business Goals
                    </Typography>
                    <Typography className="row-value">
                      {solution.businessGoals}
                    </Typography>
                  </Box>
                </Box>

                <Box className="ai-row">
                  <AttachMoneyIcon className="row-icon" />
                  <Box>
                    <Typography className="row-label">
                      Business Value
                    </Typography>
                    <Typography className="row-value">
                      {solution.businessValue}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Footer */}
              <Box className="ai-footer">
                <Chip
                  label={`Platform: ${solution.platformName}`}
                  size="small"
                />
              </Box>
            </Card>
          ))}
        </Box>
      )}
      {!showLoader && aiSolutionList.length === 0 && (
        <Box className="empty-content">
          <Typography>No approved AI solutions found.</Typography>
        </Box>
      )}
    </Paper>
  );
};
export default AiSolution;
